<template>
  <div class="right-menu__changepassword">
    <div class="right-menu__title">
      <h4>Сменить пароль</h4>
    </div>
    <div class="t-form marginBottom">
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.oldPassword }">
          <input
            type="password"
            id="change-password-old"
            v-model="data.oldPassword"
            @click="() => clearError('oldPassword')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.oldPassword }"
            for="change-password-old"
          >
            Старый пароль
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.oldPasswordText }}</span>
        </div>
      </div>
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.newPassword }">
          <input
            type="password"
            id="change-password-new"
            v-model="data.newPassword"
            @click="() => clearError('newPassword')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.newPassword }"
            for="change-password-old"
          >
            Новый пароль
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.newPasswordText }}</span>
        </div>
      </div>
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.newPassword }">
          <input
            type="password"
            id="change-password-retype"
            v-model="data.newRetypePassword"
            @click="() => clearError('newPassword')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.newRetypePassword }"
            for="change-password-retype"
          >
            Повторите новый пароль
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.newPasswordText }}</span>
        </div>
      </div>
    </div>
    <t-button type="small blue uppercase" :callback="submit"
      >Подтвердить</t-button
    >
  </div>
</template>

<script>
import Button from '@components/ui/button.vue';
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
  data: function() {
    return {
      data: {
        oldPassword: '',
        newPassword: '',
        newRetypePassword: '',
      },
      errors: {
        oldPassword: false,
        oldPasswordText: '',
        newPassword: false,
        newPasswordText: '',
      },
      errorsText: {
        empty: 'Поле не должно быть пустым',
        shortPassword: 'Пароль должен быть 6 и более символов',
        mismatchPassword: 'Введеные пароли не совпадают',
        incorrectPassword: 'Неверный пароль',
        incorrectUser: 'Пользователя с таким телефоном не существует',
      },
    };
  },
  components: {
    't-button': Button,
  },
  computed: {
    ...mapState('api', ['profilePassword', 'changePassword']),
  },
  methods: {
    ...mapActions('api', ['fetchRequest']),
    ...mapMutations('params', ['toogleChangePassword', 'toggleRightMenu']),
    validation: function() {
      let error = false;

      Object.keys(this.data).forEach((item) => {
        if (!this.data[item].trim()) {
          this.setErrors(item, 'empty');
          error = true;
        }
      });

      if (this.data.newPassword != this.data.newRetypePassword) {
        this.setErrors(this.data.newPassword, 'mismatchPassword');
        this.setErrors(this.data.newRetypePassword, 'mismatchPassword');
        error = true;
      }

      return error;
    },
    form: function(data) {
      let _form = new FormData();
      Object.keys(data).forEach((item) => _form.append(item, data[item]));
      return _form;
    },
    setErrors: function(id, error) {
      this.errors[id] = true;
      this.errors[id + 'Text'] = this.errorsText[error];
    },
    setErrorsQuery: function(id, errorText) {
      this[this.type + 'Errors'][id] = true;
      this[this.type + 'Errors'][id + 'Text'] = errorText;
    },

    clearError: function(id) {
      this.errors[id] = false;
    },

    submit: function() {
      console.log(
        {
          password: this.data.oldPassword,
          newPassword: this.data.newPassword,
        },
        this.validation()
      );

      if (this.validation()) return;

      this.fetchRequest({
        url: this.changePassword,
        form: this.form({
          password: this.data.oldPassword,
          newPassword: this.data.newPassword,
        }),
        success: (data) => {
          console.log('success', data);

          if (data.body.success) {
            this.toogleChangePassword();
            this.toggleRightMenu();
          } else {
            try {
              this.setErrorsQuery('oldPassword', data.body.error.password[0]);
            } catch (e) {}
          }
        },
        error: (e) => {
          console.log('error', e);
        },
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.marginBottom
  margin-bottom: 32px
</style>



// WEBPACK FOOTER //
// src/templates/components/right-menu/ui/changepassword.vue